
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getBenefits} from 'sr/utils/api/masterData/benefits/getBenefits'
export const fetchbenefits = createAsyncThunk(
  'getBenefits',
  async () => {
    const response = await getBenefits()
    return response?.data
  }
)


